import { Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import { useEffect } from "react";
import { getUser, applyTheme, buildCustomCssVars } from "auth/Authentication";

const App = () => {
  useEffect(() => {
    const user = getUser();
    if (user && user.theme) {
      // If the user has saved a custom theme, apply it; otherwise apply the selected stock theme
      const mode = user.themeMode || "light";
      const savedColors = user.customTheme && ("light" in user.customTheme || "dark" in user.customTheme)
        ? user.customTheme[mode]
        : user.customTheme;
      const customCssVars =
        user.useCustomTheme && savedColors
          ? buildCustomCssVars(savedColors as Record<string, string>, mode)
          : undefined;
      applyTheme(user.theme, customCssVars, mode);
    }
  }, []);

  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/auth" replace />} />
        <Route path="auth/*" element={<AuthLayout />} />
        <Route path="admin/*" element={<AdminLayout />} />
      </Routes>
    </>
  );
};

export default App;